import { useState } from 'react';

import { MixpanelEvents } from '@/shared/thirdParty';
import { Project } from '@/shared/types/Project';

type SkippedFeedback = {
  ab?: string[];
  lipSync?: string[];
  tts?: string[];
};

type UseSkipFeedback = {
  name: 'ab' | 'lipSync' | 'tts';
  projectId?: Project['id'];
};

const SESSION_STORAGE_INITIAL_VALUE = {
  ab: [],
  lipSync: [],
  tts: [],
};

const MIXPANEL_EVENTS = {
  ab: MixpanelEvents.ttsFirstProjectFeedbackClosed,
  lipSync: MixpanelEvents.feedbackLipsyncNewFormClosed,
  tts: MixpanelEvents.feedbackNewFormClosed,
};

const SESSION_STORAGE_ITEM = 'skippedFeedback';

export const useSkipProjectFeedback = ({ name, projectId }: UseSkipFeedback) => {
  const sessionStorageItem = sessionStorage.getItem(SESSION_STORAGE_ITEM);

  const parsedData = sessionStorageItem ? (JSON.parse(sessionStorageItem) as SkippedFeedback) : {};

  const skippedFeedbacks = parsedData[name] ?? SESSION_STORAGE_INITIAL_VALUE[name];

  const isFeedbackSkipped = skippedFeedbacks?.includes(projectId ?? '');

  const [isSkipped, setIsSkipped] = useState(isFeedbackSkipped);

  const skipFeedback = () => {
    if (!projectId) {
      return;
    }

    const updatedSkippedFeedbacks = {
      ...parsedData,
      [name]: [...skippedFeedbacks, projectId],
    };

    sessionStorage.setItem(SESSION_STORAGE_ITEM, JSON.stringify(updatedSkippedFeedbacks));

    setIsSkipped(true);
    MIXPANEL_EVENTS[name]();
  };

  return {
    isFeedbackSkipped: isSkipped,
    skipFeedback,
  };
};
